import Lenis from '@studio-freight/lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Elemente, in denen Lenis das native Scrollen NICHT abfangen soll (sonst laesst
// sich ihr Inhalt nicht mit dem Mausrad scrollen). Neben unseren Modals gehoert
// dazu Elfsights Portal-Root (.es-portal-root), in das z.B. das "mehr lesen"-
// Popup der Google-Bewertungen gerendert wird (#224369).
const LENIS_PREVENT_SELECTOR = '.modal,.dcCookieModal,.es-portal-root';

function markLenisPrevent(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(LENIS_PREVENT_SELECTOR)) {
        node.dataset.lenisPrevent = 'true';
    }
    for (const el of node.querySelectorAll(LENIS_PREVENT_SELECTOR)) {
        el.dataset.lenisPrevent = 'true';
    }
}

export function initLenis() {
    markLenisPrevent(document.body);

    const lenis = new Lenis();

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    // Modals/Portale, die erst nach dem Init erzeugt werden (z.B. Elfsight-Widget,
    // das sein Popup asynchron an <body> haengt), nachtraeglich markieren.
    const addedObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                markLenisPrevent(node);
            }
        }
    });
    addedObserver.observe(document.body, { childList: true, subtree: true });

    const observer = new MutationObserver(() => {
        if (getComputedStyle(document.body).overflow === 'hidden') {
            lenis.stop();
        } else {
            lenis.start();
        }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });

    return lenis;
}
